import { useQuery } from '@tanstack/react-query';
import { useLocation } from '@/shared/hooks/useLocation';
import { seoKeys } from '../queryKeys';
import { visibilityApi } from '../api/visibilityApi';

const STALE_MINUTES = 5; // engine results refresh weekly; aggressive polling pointless

export function useAIVisibilityScore() {
  const { currentLocation } = useLocation();
  const locationId = currentLocation?.id ?? '';
  return useQuery({
    queryKey: seoKeys.aiVisibilityScore(locationId),
    queryFn: () => visibilityApi.getScore(locationId).then((r) => r.data),
    enabled: !!locationId,
    staleTime: STALE_MINUTES * 60_000,
    refetchOnWindowFocus: false,
  });
}

export function useAIVisibilityQuestions() {
  const { currentLocation } = useLocation();
  const locationId = currentLocation?.id ?? '';
  return useQuery({
    queryKey: seoKeys.aiVisibilityQuestions(locationId),
    queryFn: () => visibilityApi.getQuestions(locationId).then((r) => r.data),
    enabled: !!locationId,
    staleTime: STALE_MINUTES * 60_000,
    refetchOnWindowFocus: false,
  });
}

export function useAIVisibilityCompetitorShare() {
  const { currentLocation } = useLocation();
  const locationId = currentLocation?.id ?? '';
  return useQuery({
    queryKey: seoKeys.aiVisibilityCompetitorShare(locationId),
    queryFn: () => visibilityApi.getCompetitorShare(locationId).then((r) => r.data),
    enabled: !!locationId,
    staleTime: STALE_MINUTES * 60_000,
    refetchOnWindowFocus: false,
  });
}
